(() => {
  if (window.__sohimiOrderAttributionInstalled || typeof window.fetch !== 'function') return;
  window.__sohimiOrderAttributionInstalled = true;

  const storageKey = 'sohimi_order_attribution_v1';
  const maxAgeMs = 30 * 24 * 60 * 60 * 1000;
  const maxLength = 100;

  function clean(value) {
    if (typeof value !== 'string') return '';
    return value.trim().toLowerCase().replace(/[^a-z0-9._-]+/g, '_').replace(/^_+|_+$/g, '').slice(0, maxLength);
  }

  function readStored() {
    try {
      const stored = JSON.parse(window.localStorage.getItem(storageKey) || 'null');
      if (!stored || typeof stored !== 'object' || Date.now() - Number(stored.updatedAt || 0) > maxAgeMs) return null;
      return stored;
    } catch (_) {
      return null;
    }
  }

  function saveStored(value) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(value));
    } catch (_) {}
  }

  function readIncoming() {
    const url = new URL(window.location.href);
    const creator = clean(url.searchParams.get('creator') || url.searchParams.get('influencer') || url.searchParams.get('partner'));
    const source = clean(url.searchParams.get('utm_source'));
    const medium = clean(url.searchParams.get('utm_medium'));
    const campaign = clean(url.searchParams.get('utm_campaign'));
    const content = clean(url.searchParams.get('utm_content'));

    if (!source && !creator && !campaign) return null;

    return {
      source,
      medium,
      campaign,
      content,
      creator,
      landingPath: url.pathname.slice(0, maxLength),
      recordedAt: Date.now(),
    };
  }

  function cartAttributes(first, last) {
    return {
      __attr_version: '1',
      __attr_first_source: first.source,
      __attr_first_medium: first.medium,
      __attr_first_campaign: first.campaign,
      __attr_first_content: first.content,
      __attr_first_creator: first.creator,
      __attr_first_landing: first.landingPath,
      __attr_last_source: last.source,
      __attr_last_medium: last.medium,
      __attr_last_campaign: last.campaign,
      __attr_last_content: last.content,
      __attr_last_creator: last.creator,
      __attr_last_landing: last.landingPath,
    };
  }

  async function updateCart(attributes) {
    const root = window.Shopify?.routes?.root || '/';
    const endpoint = `${root.replace(/\/$/, '')}/cart/update.js`;
    try {
      await window.fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes }),
        keepalive: true,
      });
    } catch (_) {}
  }

  const incoming = readIncoming();
  if (!incoming) return;

  const stored = readStored();
  const first = stored?.first || incoming;
  const state = { first, last: incoming, updatedAt: Date.now() };
  saveStored(state);
  updateCart(cartAttributes(first, incoming));
})();
